// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HD18C","buttons":"styles_buttons__3c3jU"};